import { Link } from 'react-router-dom';

export function Breadcrumbs({ items }: { items: { label: string; to?: string }[] }) {
  return (
    <nav aria-label="Broodkruimel" className="text-sm text-ct-muted">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, i) => (
          <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
            {i > 0 ? <span aria-hidden className="text-ct-border">/</span> : null}
            {item.to ? (
              <Link to={item.to} className="font-medium text-ct-accent hover:underline">
                {item.label}
              </Link>
            ) : (
              <span className="text-ct-text">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
